<template>
  <div class="box-forgot-password-verify clearfix">
    <div class="box-title">{{ labels['50'] }}</div>

    <div class="box-intro">
      {{ labels['160'] }}
    </div>

    <label class="box-input-material clearfix">
      <div class="fa fa-shield icon-id"></div>
      <input  :class="{ 'focus' : otpCode != '', 'input-error' : errors.has('otpCode')}"
              v-model="otpCode"
              @keyup="clearResponse()"
              name="otpCode"
              v-validate="'required'">
      <span>{{ labels['150'] }}</span>
      <div class="login-validate" v-show="errors.has('otpCode')">{{ errors.first('otpCode') }}</div>
    </label>

    <div class="infinite-loading-container" v-if="loadingDisp"><i class="loading-wave-dots"></i></div>
    <div class="response-msg" v-show="response !== ''">{{ response }}</div>

    <button class="btn-forgot submit" v-on:click="validateInput()" v-show="!dispBtnOk">{{ labels['120'] }}</button>
    <button class="btn-forgot cancel" v-on:click="cancel()" v-show="!dispBtnOk">{{ labels['110'] }}</button>
    <button class="btn-change submit" v-on:click="cancel()" v-show="dispBtnOk">{{ labels['130'] }}</button>
  </div>
</template>

<script>
export default {
  name: 'forgot-password-verify',
  data () {
    return {
      otpCode: ''
    }
  },
  props: [ 'pcDisp', 'loadingDisp', 'goLogin', 'postForgotPasswordVerify', 'response', 'setResponse', 'inputUsername', 'labels' ],
  methods: {
    clearResponse () {
      this.setResponse('')
    },
    validateInput () {
      this.setResponse('')
      this.$validator.validateAll().then(result => {
        if (result) {
          var formForgotPassword = {
            forg_otpcode: this.otpCode
          }
          this.postForgotPasswordVerify(formForgotPassword)
          // this.otpCode = ''
          this.clear()
        }
      })
    },
    cancel () {
      this.clear()
      this.goLogin()
    },
    clear () {
      this.otpCode = ''
      this.clearResponse()
      this.errors.clear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// forgotPasswordVerify.vue?12ac7187